import { render, staticRenderFns } from "./CustomerModal.vue?vue&type=template&id=25c534f2&"
import script from "./CustomerModal.vue?vue&type=script&lang=js&"
export * from "./CustomerModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomerModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports